var React = require('react');

function ShareYt (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"19","height":"19","rx":"9.5","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.8039 6.23558C14.2751 6.36244 14.6466 6.73393 14.7734 7.2051C15.009 8.06589 15 9.85995 15 9.85995C15 9.85995 15 11.645 14.7734 12.5057C14.6466 12.9769 14.2751 13.3484 13.8039 13.4753C12.9431 13.7018 9.49998 13.7018 9.49998 13.7018C9.49998 13.7018 6.06589 13.7018 5.19604 13.4662C4.72487 13.3393 4.35338 12.9678 4.22652 12.4967C4 11.645 4 9.85089 4 9.85089C4 9.85089 4 8.06589 4.22652 7.2051C4.35338 6.73393 4.73393 6.35338 5.19604 6.22652C6.05683 6 9.49998 6 9.49998 6C9.49998 6 12.9431 6 13.8039 6.23558ZM11.2668 9.85087L8.40356 11.5V8.20178L11.2668 9.85087Z","fill":"#141B2B","key":1})]);
}

ShareYt.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = ShareYt;

ShareYt.default = ShareYt;
